import { render, staticRenderFns } from "./previousWork.vue?vue&type=template&id=7dfa27d6&scoped=true"
import script from "./previousWork.vue?vue&type=script&lang=js"
export * from "./previousWork.vue?vue&type=script&lang=js"
import style0 from "./previousWork.vue?vue&type=style&index=0&id=7dfa27d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfa27d6",
  null
  
)

export default component.exports